import React from 'react'

export default {

  path: `/ping`,

  async action () {
    return {
      title: 'Pong',
      component: <div>pong</div>
    }
  }

}
